import React from 'react';
import { Alert } from '@mui/material';
import { useTypedSelector } from 'hooks/useTypedSelector';

export const ValidationBlock: React.FC = () => {
  const { error, message } = useTypedSelector((state) => state.global);

  return (
    <div className="field-list validation-block">
      <div className="data-name" style={{ width: '100%' }}>
        {error ? (
          <Alert severity="error" variant="outlined" style={{ border: 'none' }}>
            {error}
          </Alert>
        ) : message ? (
          <Alert severity="success" variant="outlined" style={{ border: 'none' }}>
            {message}
          </Alert>
        ) : (
          <p>&nbsp;</p>
        )}
      </div>
    </div>
  );
};
